module.exports = __webpack_public_path__ + "img/address.9e560d2d.svg";